export default __webpack_public_path__ + "static/media/short-logo.9e63daea.png";